module.exports = __webpack_public_path__ + "img/16_119.ee5daeaf.png";